var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKuwait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 37,
    viewBox: "0 0 51 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_88156)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.175781,
    y: 0.225586,
    width: 50.4,
    height: 36,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.175781 24.2256H50.5758V36.2256H0.175781V24.2256Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.175781 0.225586H50.5758V12.2256H0.175781V0.225586Z",
    fill: "#249F58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.175781 36.3048V0.225586L16.9758 12.2256V24.2256L0.175781 36.3048Z",
    fill: "#151515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_88156"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.175781,
    y: 0.225586,
    width: 50.4,
    height: 36,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuwait);
export default __webpack_public_path__ + "static/media/Kuwait.8bf132ba48d8578f892b8c61f7a10058.svg";
export { ForwardRef as ReactComponent };